import Message from './Message';
import type { MessageProps } from './Message.types';

export type { MessageProps };
export { Message };
export default Message;
